import { initCardGrid } from '../../library/components/card-grid/card-grid';
import { initSiteHeader } from '../../library/components/header/header';
import { initProductTiers } from '../../library/components/product-tiers/product-tiers';
import { initCarousel } from '../../library/components/carousel/carousel';
import { initTopicSelector } from '../../library/components/topic-selector/topic-selector';
import { initAssistanceComponent } from '../../library/components/assistance-component/assistance-component';
import { initHeaderWithSearch } from '../../library/components/header-with-search/header-with-search';
import { initSubTopics } from '../../library/pages/subtopics';
import { initTrustpilotBanner } from '../../library/components/trustpilot-banner/trustpilot-banner';
import { initSegmentedToggle } from '../../library/components/segmented-toggle/segmented-toggle';
import { initSearchResults } from '../../library/pages/search-results';
import { initArticleFeedback } from '../../library/components/article-feedback/article-feedback';

function init(): void {
  initSiteHeader();
  initCardGrid();
  initProductTiers();
  initCarousel();
  initTopicSelector();
  initAssistanceComponent();
  initHeaderWithSearch();
  initSubTopics();
  initTrustpilotBanner();
  initSegmentedToggle();
  initSearchResults();
  initArticleFeedback();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
